import React from 'react'
import Logo from '../logo'
import SidebarItem from './sidebarItem';
import SidebarItemMenu from './sidebarItemMenu';
import HomeIcon from '../../assets/icons/Home'
import Menu from './sidebarMenu'
const Sidebar = ({ sidebarStatus, isSmallScreen }) => {
    return (
        <aside className={`sidebar ${sidebarStatus == false ? 'closed' : ''} ${isSmallScreen && 'small-screen'}`}>
            <div className="sidebar-header">
                <Logo imageType={'wide'} />
            </div>
            <div className="sidebar-content">
                <ul className='sidebar-items'>
                    {
                        Menu.map((item, index) => {
                            return (
                                item.subMenu &&
                                <SidebarItemMenu key={index} title={item.title} icon={item.icon} path={item.path} subMenu={item.subMenu} />
                                ||
                                <SidebarItem key={index} title={item.title} icon={item.icon} path={item.path} />
                            )
                        })
                    }
                </ul>
            </div>
        </aside>
    )
}

export default Sidebar
